import { Icon56MoneyTransferOutline } from "@vkontakte/icons";
import s from "./style.module.scss";
import { CloseButton } from "@/components/CloseButton/CloseButton";
import { UIButton } from "@/components/UIButton/UIButton";
interface GarantyModalProps {
  closeModal: () => void;
}
export const AuthErrorAlert = (props: GarantyModalProps) => {
  const { closeModal } = props;
  return (
    <div className={s.wrapper}>
      <CloseButton onClose={closeModal} />
      <p className={s.description}>
        Для работы с приложением необходимо авторизоваться в аккаунте заказчика-физлица на FL.ru
      </p>
      <UIButton
        fontType={"primary-2"}
        className={s.button}
        color="light-green-2"
        onClick={closeModal}
        size="thin"
      >
        Хорошо
      </UIButton>
    </div>
  );
};
